import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

import { AvatarGroupDialogData, AvatarItem } from '@app/ui/avatar-group/avatar-group.component';

@Component({
  selector: 'sbnb-dialog-avatar-group',
  templateUrl: './dialog-avatar-group.component.html',
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogAvatarGroupComponent implements OnInit {
  public items: AvatarItem[];
  public itemsForLabel: string;
  public itemLink: string;
  constructor(
    public dialogRef: MatDialogRef<DialogAvatarGroupComponent>,
    @Inject(MAT_DIALOG_DATA)
    public dialogData: AvatarGroupDialogData
  ) {}

  ngOnInit() {
    this.items = this.dialogData.items;
    this.itemsForLabel = this.dialogData.itemsForLabel;
    this.itemLink = this.dialogData.itemLink;
  }

  close() {
    this.dialogRef.close();
  }

  getItemLink(item: AvatarItem) {
    if (!this.itemLink || !item.id) {
      return null;
    }
    return this.itemLink.replace(':id', item.id.toString());
  }
}
